import React, { useEffect } from 'react';
import ItemDetail from './ItemDetail';

// Modal wrapper around ItemDetail. Used by the Price Impact card "see →" links so clicking
// a contributor opens a focused view without leaving the dashboard.
export default function ItemDetailModal({
  open,
  item,
  onClose,
  priceHistory,
  regional,
  companyRegion,
  foodItems,
  rangeDays,
  expandedHistoryEntries,
  onToggleHistoryEntry,
  editingHistoryEntry,
  editPriceValue, setEditPriceValue,
  editQtyValue, setEditQtyValue,
  editLineTotalValue, setEditLineTotalValue,
  onStartEditEntry,
  onCancelEditEntry,
  onSaveEditEntry,
}) {
  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || !item) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center modal-backdrop"
      style={{ background: 'rgba(0,0,0,0.4)' }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto modal-content"
        style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6 border-b border-gray-100 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#111827" strokeWidth="2"><path d="M3 3v18h18M7 14l4-4 4 4 6-6"/></svg>
            <h2 className="text-base font-semibold text-gray-900">Item detail</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-lg" aria-label="Close">&times;</button>
        </div>
        <div className="p-6 bg-gray-50">
          <ItemDetail
            item={item}
            priceHistory={priceHistory}
            regional={regional}
            companyRegion={companyRegion}
            foodItems={foodItems}
            rangeDays={rangeDays}
            expandedHistoryEntries={expandedHistoryEntries}
            onToggleHistoryEntry={onToggleHistoryEntry}
            editingHistoryEntry={editingHistoryEntry}
            editPriceValue={editPriceValue}
            setEditPriceValue={setEditPriceValue}
            editQtyValue={editQtyValue}
            setEditQtyValue={setEditQtyValue}
            editLineTotalValue={editLineTotalValue}
            setEditLineTotalValue={setEditLineTotalValue}
            onStartEditEntry={onStartEditEntry}
            onCancelEditEntry={onCancelEditEntry}
            onSaveEditEntry={onSaveEditEntry}
          />
        </div>
      </div>
    </div>
  );
}
